import React from 'react';
import PropTypes from 'prop-types';
import { notice } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';
import convertToFormErrors from 'utils/convertToFormErrors';
import api from 'api';
import { withRouter, Link } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import SubmitButton from 'form/SubmitButton';
import Component from 'BaseComponent';
import autobind from 'autobind-decorator';

@withRouter

@reduxForm({
  form: 'Register',
  validate: generateFormValidation({
    name: [validators.required()],
    email: [validators.required(), validators.email()],
  }),
})

export default class Register extends Component {

  static propTypes = {
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }

  @autobind
  onSubmit(values) {
    const { dispatch } = this.props;
    return dispatch(api.createAccount({
      data: {
        type: 'account',
        attributes: values,
      },
    }))
    .then(() => {
      dispatch(notice('Register.confirmationSent'));
      this.props.history.push('/confirmation_sent');
    })
    .catch((response) => {
      return Promise.reject(convertToFormErrors(response));
    });
  }

  render() {
    const { handleSubmit, submitting, error, dirty } = this.props;

    return (
      <div className="island">
        <div className="island__wrap">
          <a href="https://www.hardypress.com">
            <div className="island__title island__title--register" />
          </a>
          <div className="island__content">
            <div className="island__content__title">
              Request access
            </div>
            <Form error={error} onSubmit={handleSubmit(this.onSubmit)}>
              <Field
                label="Register.name"
                name="name"
                placeholder="Mark Smith"
              >
                <input type="text" className="form__input" />
              </Field>
              <Field
                label="Register.email"
                name="email"
                placeholder="mark.smith@gmail.com"
              >
                <div>
                  <input type="text" className="form__input" />
                  <small>GMail and other free email providers are not allowed</small>
                </div>
              </Field>
              <Field
                label="Additional info about you or your business"
                name="additionalInfo"
              >
                <textarea rows="5" className="form__input" />
              </Field>
              <SubmitButton
                dirty={dirty}
                className="button button--primary button--expand"
                submitting={submitting}
                label="Register.submit"
              />
              <p className="space--top-2 align--center">
                By signing up, you agree to the
                <a href="https://www.hardypress.com/terms/" target="_blank" rel="noopener noreferrer"> Terms of Service </a>
                and
                <a href="https://www.iubenda.com/privacy-policy/8169884" target="_blank" rel="noopener noreferrer"> Privacy policy </a>
              </p>
            </Form>
          </div>
          <div className="island__footer">
            Already have an account?&nbsp;
            <Link to="/login">
              {this.t('Register.login')}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Register.jsx